import { FleekError } from './FleekError';

type AuthorizationErrorOptions = object;

export class AuthorizationError extends FleekError<AuthorizationErrorOptions> {
  public name = 'AuthorizationError';

  constructor() {
    super({});
  }

  toString = () => `Authorization with provided credentials is invalid.`;
}
